module.exports = __webpack_public_path__ + "static/media/venetian12.0d6f629e.png";